import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';

import { getCssSize, getDataRole } from './Panel.helpers';
import { type DataRoleProps, type PanelGridColumns } from './Panel.types';

import './PanelGrid.less';

const block = bemBlock('n-Panel');

export type PanelGridProps = React.HTMLAttributes<HTMLDivElement> &
  DataRoleProps & {
    columns?: PanelGridColumns;
    equalHeightItems?: boolean;
    minColumnWidth?: number | string;
  };

export const PanelGrid = React.forwardRef<HTMLDivElement, PanelGridProps>(function PanelGrid(
  {
    children,
    className,
    columns = 1,
    dataRole,
    equalHeightItems,
    minColumnWidth = 140,
    style,
    'data-role': dataRoleAttribute,
    ...passProps
  },
  ref,
) {
  const gridStyle = {
    ...style,
    '--n-panel-grid-min-column-width': getCssSize(minColumnWidth),
  } as React.CSSProperties;

  return (
    <Layout.Element
      {...passProps}
      elementRef={ref}
      className={block({
        element: 'grid',
        modifiers: { columns, 'equal-height-items': equalHeightItems },
        extra: className,
      })}
      data-role={getDataRole(dataRole, dataRoleAttribute)}
      style={gridStyle}
    >
      {children}
    </Layout.Element>
  );
});
